import styled from "styled-components";

const HeaderContainer = styled.div`
  display: flex;
  background: #683d8c;
`;

const MenuContainer = styled.div`
  display: flex;
  margin: 0;
  padding: 0;

    img {
      margin: 0.5em;
      width: 2em;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  
    width: 120%;
    
  }
`;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  color: #fff;
  font-size: 2em;
  justify-content: center;

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    font-size: 1.75em;
  }

  img {
    margin-top: 0.5em;
    margin-bottom: -1em;
    border: 1em solid #683d8c;
    border-radius: 1.5rem;
    border-top: none;
    z-index: 1;
    width: 5em;
  }
`;

const SettingsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;

  img {
    margin: 0em 2.5em;
    cursor: pointer;

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin: 0em 1.5em;
      width: 6em;
    }
  }
`;

const LogoutContainer = styled.div`
  display: ${props => (props.open ? "block" : "none")} 
  background: white;
  position: absolute;
  top: 12%;
  right: 1%;
  border: 2px solid rebeccapurple;
  border-radius: 1em;
  padding: 1em;


  @media (max-width: 1440px) {
    top: 13%;
  }


`;

export {
  HeaderContainer,
  MenuContainer,
  ProfileContainer,
  SettingsContainer,
  LogoutContainer
};
